import React from 'react'
import styles from './ProgressBar.module.css'

const ProgressBar = ({ currentStep, totalSteps = 5 }) => {
    const progressPercentage = ((currentStep + 1) / totalSteps) * 100

    return (
        <div className={styles.progressContainer}>
            <div className={styles.progressBarWrapper}>
                <div className={styles.progressBarTrack}>
                    <div
                        className={styles.progressBarFill}
                        style={{width: `${progressPercentage}%`}}
                    />
                </div>
                <div
                    className={styles.progressHandle}
                    style={{left: `calc(${progressPercentage}% - 12px)`}}
                />
            </div>
            <div className={styles.progressText}>
                {currentStep + 1}/{totalSteps}ステップ
            </div>
        </div>
    )
}

export default ProgressBar